import { PortalSelectedLoan } from '../../../App';
import { Banner } from '../banner/Banner';
import { PortalNav } from '../nav/Nav';

import './Header.scss';

interface Props {
  loan?: PortalSelectedLoan;
  hideSideNav?: boolean; // display reduced nav is no active loan selected (ie loan switch view)
}

export const Header = ({ loan, hideSideNav }: Props) => {
  const { company, losId } = loan || {};
  const hasActiveLoan = Boolean(loan); // display reduced nav is no active loan found

  return (
    <header className="header">
      <a href="#main" className="skip-nav">
        Skip to Content
      </a>

      <Banner selectedLoanId={losId} hasActiveLoan={hasActiveLoan} company={company} />

      {!hideSideNav && (
        <PortalNav
          selectedLoanId={losId}
          loanStatus={loan?.currentSnapshot?.loanStatus}
          hasActiveLoan={hasActiveLoan}
          company={company}
        />
      )}
    </header>
  );
};
